import escape from "lodash/escape";
import unescape from "lodash/unescape";

const WRAPPER_ELEMENT_START =
  "<span class='txu-cat-tag' contenteditable='false'>";
const WRAPPER_ELEMENT_END = "</span>";

type Tags = Set<string>;

export class TranslationMemorySegmentTagRule {
  public _regex: RegExp;
  public id: number;
  public name?: string;

  constructor(regex: RegExp, id: number, name?: string) {
    this._regex = regex;
    this.id = id;
    this.name = name;
  }

  public findTags(text: string): Tags {
    const globalRe = this._regex.global
      ? this._regex
      : new RegExp(this._regex.source, this._regex.flags + "g");
    const matches = text.matchAll(globalRe);
    const tags: Tags = new Set([]);

    for (const match of matches) {
      const matchedText = match[0];
      tags.add(matchedText);
    }
    return tags;
  }
  get regex(): string {
    return this._regex.source;
  }
}

export class TranslationMemorySegmentTagRules {
  public rules: TranslationMemorySegmentTagRule[];

  constructor(rules: TranslationMemorySegmentTagRule[]) {
    this.rules = rules;
  }

  public apply(text: string, exclude_rules: number[] = []): string {
    let escapedText = escape(text);
    const tags = this.rules
      .filter((rule) => !exclude_rules.includes(rule.id))
      .map((rule) => rule.findTags(text));

    tags.map((tag) => {
      tag.forEach((match) => {
        const escapedTagKey = escape(match);
        const replacement = `${WRAPPER_ELEMENT_START}${escapedTagKey}${WRAPPER_ELEMENT_END}`;
        escapedText = escapedText.replaceAll(escapedTagKey, replacement);
      });
    });
    return escapedText;
  }
}

export function cleanFilters(text: string): string {
  const removedSpans = text
    .replaceAll(WRAPPER_ELEMENT_START, "")
    .replaceAll(WRAPPER_ELEMENT_END, "");
  return unescape(removedSpans);
}
